export enum EChannelPlatform {
  facebook = 'facebook',
  instagram = 'instagram',
  linkedin = 'linkedin',
  pinterest = 'pinterest',
  x = 'x',
}
